<template>
  <div>
    <div class="WisdomSiteContainer">
      <Row justify="center" type="flex">
        <Col span="24">
          <img
            style="width: 100%; height: 400px"
            src="../../static/img/WisdomSite/背景2.png"
            alt="#"
          />
        </Col>
        <Col :xs="25" :sm="25" :md="15" :lg="15" :xl="15">
          <div style="margin-left: 10px">
            <router-view></router-view>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
      menuTheme: "light",
      CompanyProfile: [
        {
          url: "../../static/img/photo-da/photo_huitan.jpg",
          intro: "无线蓝牙回弹仪",
          path: "Resiliometer",
        },
        {
          url: "../../static/img/photo/photo_anquan.png",
          intro: "安全隐患排查系统",
          path: "HiddenDanger",
        },
      ],
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    goBackBuy(path) {
      this.$router.push({
        name: path,
      });
    },
  },
};
</script>

<style scoped>
.consult_div {
  font-size: 18px;
  font-family: "Microsoft YaHei", serif;
  margin: 10px;
  line-height: 34px;
  border: 3px solid #02a0e7;
  border-radius: 20px;
  text-align: center;
}

.consult_div span {
  font-size: 20px;
  color: #02a0e7;
}

/*跳转到公司产品上面*/
.com_profile {
  margin-top: 10px;
  background: #eeeeee;
  cursor: pointer;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
}

.com_profile:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.com_profile div {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.com_profile div img {
  width: 80%;
  height: 180px;
}

.com_profile p {
  text-align: center;
  margin-bottom: 10px;
}

.aboutAs_row {
  background-color: white;
  padding-top: 40px;
}

.aboutAs_div {
  width: 238px;
  height: 102px;
  text-align: center;
  background: url("../../static/img/AboutUs/bg5.jpg") no-repeat left;
}

.aboutAs_div_bgImg {
  width: 238px;
  height: 82px;
  text-align: center;
  background: #02a0e7;
  background: url("../../static/img/AboutUs/bg5.jpg") no-repeat left;
}

.aboutAs_div_bgImg div {
  font-size: 26px;
  color: #ffffff;
  font-family: 新宋体, serif;
  padding-top: 20px;
}

.aboutAs_div01 {
  font-size: 30px;
  color: #ffffff;
  font-family: 新宋体, serif;
  padding-top: 28px;
}

.buy_menu {
  width: 100%;
  background: #dddddd;
  margin-bottom: 20px;
}

.buy_menu ul {
  z-index: 1;
}

.buy_menu ul a {
  margin-top: 6px;
  font-size: 16px;
  font-family: 微软雅黑, serif;
  background-image: linear-gradient(to bottom, #fff, #f7f7f7);
}

.buy_menu ul a img {
  position: relative;
  top: 2px;
  margin-left: -14px;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue